import { useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";

export default function useBookDemoButton() {
    const url = "/plan/hasPaidPlan/";
    const { data: hasPaidPlan, isLoading } = useDotLegalQueryWithKey<boolean>(url, url);

    return { hasPaidPlan, isLoading };
}
